import { useQuery } from 'react-query';
import { getAllCourseOccupations } from '../../api/apiRequests/courseOccupations';
import { day } from '../../lib/helpers/time.helper';
import { ICourseOccupation } from '../../lib/interfaces/CourseOccupation';
import MainLayout from '../Smart/Layouts/MainLayout';
import CoursesList from './CoursesList';
import CoursesSidebar from './CoursesSidebar';

const CoursesLayout = () => {
	const { data: courseOccupations } = useQuery<ICourseOccupation[], Error>(
		['course-occupations'],
		() => getAllCourseOccupations(),
		{
			staleTime: day,
		},
	);

	return courseOccupations ? (
		<MainLayout
			content={<CoursesList courseOccupations={courseOccupations} />}
			sidebar={<CoursesSidebar courseOccupations={courseOccupations} />}
		/>
	) : null;
};

export default CoursesLayout;
